import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemConstants } from "../TandemConstants";
import { TandemEventDefinition } from "../TandemTypes";

type BolusMapping = (typeof TandemConstants)["BOLUS_TYPE"];
type BolusType = BolusMapping[keyof BolusMapping]["name"] | "Unknown";

export type BolusRequested1Payload = {
  bolus_id: number;
  bolus_type?: number;
  correction_bolus_included?: number;
  carb_amount?: number;
  bg?: number;
  iob?: number;
  carb_ratio?: number;
};

export type BolusRequested1Event = {
  bolusId: number;
  bolusType: BolusType;
  correctionBolusIncluded?: number;
  carbAmount?: number;
  bg?: number;
  iob?: number;
  carbRatio?: number;
};

const bolusRequested1Schema = z.object({
  bolus_id: z.number(),
  bolus_type: cz.permissive(z.number()),
  correction_bolus_included: cz.permissive(z.number()),
  carb_amount: cz.permissive(z.number()),
  bg: cz.permissive(z.number()),
  iob: cz.permissive(z.number()),
  carb_ratio: cz.permissive(z.number()),
});

const getBolusType = (bolusType?: number): BolusType => {
  const bolusMapping = TandemConstants.BOLUS_TYPE;
  for (const i in bolusMapping) {
    const item = bolusMapping[i as keyof BolusMapping];
    if (bolusType === item.value) {
      return item.name;
    }
  }
  return "Unknown";
};

export const LID_BOLUS_REQUESTED_MSG1 = {
  value: 0x40,
  name: "Bolus Requested Event 1 of 3",
  format: "hbbhhfi",
  fields: ["bolus_id", "bolus_type", "correction_bolus_included", "carb_amount", "bg", "iob", "carb_ratio"],
  postprocess: rec => ({
    bolusId: rec.bolus_id,
    bolusType: getBolusType(rec.bolus_type),
    correctionBolusIncluded: rec.correction_bolus_included,
    carbAmount: rec.carb_amount,
    bg: rec.bg,
    iob: rec.iob,
    carbRatio: rec.carb_ratio ? rec.carb_ratio * 0.001 : undefined,
  }),
  schema: bolusRequested1Schema,
} as const satisfies TandemEventDefinition<BolusRequested1Payload, BolusRequested1Event>;
